import { TReduxActions } from '../../types/redux';
import { IAuthorizationTrapState } from '../../types/authorization_trap';
import { AUTHORIZATION_TRAP_CLOSE } from '../../constants/actionTypes/authorization_trap';

const defaultState = {
  isVisible: true,
};

export function authorizationTrapReducer(state: IAuthorizationTrapState = defaultState, action: TReduxActions) {
  switch (action.type) {
    case AUTHORIZATION_TRAP_CLOSE:
      return {
        ...state,
        isVisible: false,
      };
  }

  return state;
}
